import { makeStyles } from '@material-ui/core/styles';
import { MatchingRoundDetails } from '../../api/matching-rounds';
import MatchingRoundDetailsForm from '../../components/forms/matching-round-details';

interface MatchingRoundDetailsInfoPageProps {
  initialValues?: Partial<MatchingRoundDetails>;
  loading: boolean;
  onSubmit: (values: MatchingRoundDetails) => Promise<void>;
}

const useStyles = makeStyles({
  container: {
    padding: 40,
    flex: 1,
    minHeight: 0,
    overflow: 'auto',
  },
});

function MatchingRoundDetailsInfoPage({
  initialValues,
  loading,
  onSubmit,
}: MatchingRoundDetailsInfoPageProps) {
  const classes = useStyles();
  return (
    <div className={classes.container} data-testid='round-details-info-page'>
      <MatchingRoundDetailsForm
        loading={loading}
        onSubmit={onSubmit}
        initialValues={initialValues}
      />
    </div>
  );
}

export default MatchingRoundDetailsInfoPage;
